'use client';
import { X } from 'lucide-react';
import styles from './Header.module.css';
import log from '../utils/logger.ts';
import { HEADER_TYPES, type HeaderType } from '../constants/headerTypes';
import { postMessageHandler, POST_MESSAGE_ACTIONS } from '../utils/postMessageHandler';
import { useAccountSections } from '../hooks/useAccountSections';
import { ACCOUNT_ITEM_IDS } from '../lib/config';
import { useUser } from '../contexts/UserContext';
import { formatCurrency } from '../utils/gameUtils';

interface HeaderProps {
    onClose?: () => void;
    type?: HeaderType;
    onPromoClick?: () => void;
    onBonusClick?: (bonusUrl: string) => void;
}

const Header = ({ onClose, type = HEADER_TYPES.ALL, onPromoClick, onBonusClick }: HeaderProps) => {
    const { findItemById } = useAccountSections();
    const bonusItem = findItemById(ACCOUNT_ITEM_IDS.BONUS);
    const { user } = useUser();
    
    const handleClose = () => {
        if (onClose) {
            log.debug('sending onClose')
            onClose();
        } else  {
            log.debug('Sending postMessage to parent window:', {
                action: POST_MESSAGE_ACTIONS.CLOSE_CASINO_WEB
            });
            postMessageHandler.sendToParent(POST_MESSAGE_ACTIONS.CLOSE_CASINO_WEB);
        }
    };

    const handlePromoClick = () => {
        if (onPromoClick) {
            onPromoClick();
        }
    };

    const handleBonusClick = () => {
        if (onBonusClick && bonusItem) {
            onBonusClick(bonusItem.url);
        }
    };

    return (
        <div className={styles.header}>
            <div className={styles.headerContent}>
                <div className={styles.logoSection}>
                    <img src="/logo_header.svg" alt="SNAI CASINO" />
                </div>
                
                <div className={styles.rightSection}>
                    {type === HEADER_TYPES.ALL && (
                        <>

                            {/* Promo Button */}
                            {onPromoClick && (
                                <>
                                    <div className={styles.separator}></div>

                                    <button
                                        className={styles.promoButton}
                                        title="Promo"
                                        onClick={handlePromoClick}
                                    >
                                        <img src="/promo@2x.png" alt="Promo" className={styles.promoImage} />
                                    </button>
                                    <div className={styles.separator}></div>
                                </>

                            )}



                            {/* Bonus Button */}
                            { bonusItem && (
                                <>
                            <button
                                className={styles.bonusButton}
                                title="Bonus"
                                onClick={handleBonusClick}
                            >
                                <span>I miei<br />bonus</span>
                            </button>

                                <div className={styles.separator}></div>
                                </>
                            )}
                            
                            {/* Balance and Bonus Display */}
                            {user?.balance && (
                                <>
                                    <div className={styles.balanceContainer}>
                                        <div className={styles.balanceRow}>
                                            <span className={styles.balanceLabel}>Saldo:</span>
                                            <span className={styles.balanceValue}>{formatCurrency(user.balance)} €</span>
                                        </div>
                                        <div className={styles.balanceRow}>
                                            <span className={styles.balanceLabel}>Bonus:</span>
                                            <span className={styles.balanceValue}>{formatCurrency(user.bonus || 0)} €</span>
                                        </div>
                                    </div>
                                    
                                    <div className={styles.separator}></div>
                                </>
                            )}


                        </>
                    )}
                    
                    <button
                        onClick={handleClose}
                        className={styles.closeButton}
                        title="Chiudi"
                    >
                        <X size={24} />
                    </button>
                </div>
            </div>
        </div>
    );
};


export default Header;
